import React from 'react'
import AziendaFrom from '../../rightSidebar/AziendaFrom'
import { Box } from '@mui/material'
import ProdottiForm from '../Prodotti/ProdottiForm'
import { useDispatch, useSelector } from 'react-redux'
export const CantineProdottiSlider = ({ cantine, setCantine }) => {
    const cantineSingleData = useSelector((state)=> state.cantine.singleCantines)
    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un Prodotto</h2>
            </Box>
            <ProdottiForm cantine={cantine} setCantine={setCantine} cantineSingleData={cantineSingleData}/>
        </Box>
    )
}